export default {"src":"/_next/static/media/login-b2b-bg-responsive.270dd230.svg","height":718,"width":374};